// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';
import moment from "../../../plugins/moment";


export default {

    async searchMessages(ctx, params){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            },
            params : {
                page: params.page,
                from_created_at: moment(params.from_created_at).format('YYYY-MM-DD HH:mm'),
                to_created_at: moment(params.to_created_at).add('23', 'hours').add('59', 'minutes').format('YYYY-MM-DD HH:mm'),
                device_id: params.device_id,
                perPage: params.perPage,
            }
        };
        try {
            ctx.state.isSearchDone = false
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/message/search`, config);
            await ctx.commit('updateMessages', response.data)
            if(!ctx.state.isSearchDone){
                params.page += 1
                await ctx.dispatch('searchMessages', params)
            } else {
                await ctx.commit('updateMessagesFields')
            }
            
            
            return response.data
        } catch (error) {
            return error;
        }
    },
    async fetchLastByDevices(ctx, payload){
        const access_token = ctx.rootGetters.access_token;
        const response = await axios.post(
            `${process.env.VUE_APP_APIGATEWAY}/api/v1/message/lasts-by-devices`,
            {
                device_ids:payload
            }, 
            {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'Authorization': `${access_token}`
                    },
            }
        );
        if(response.data){
            ctx.commit('updateLastDevicesMessages', response.data.data)
        } else {
            ctx.commit('updateLastDevicesMessages', [])
        }
    },
    async fetchUpdateLastByDevice(ctx, payload){
        const access_token = ctx.rootGetters.access_token;
        let updatedValueIndex = ctx.state.lastDevicesMessages.findIndex(item=>item.device_id === payload[0])
        if(updatedValueIndex === -1){ //если нет в списке мы даже и не обновляем
            return
        }
        console.log('fetchUpdateLastByDevice', payload)
        const response = await axios.post(
            `${process.env.VUE_APP_APIGATEWAY}/api/v1/message/lasts-by-devices`,
            {
                device_ids:payload
            },
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `${access_token}`
                },
            }
        );
        if(response.data){
            ctx.commit('updateLastDevice', response.data.data)
        }
    }
};
